module.exports = __webpack_public_path__ + "img/Subtract.687ac5c9.svg";